// extracted by mini-css-extract-plugin
module.exports = {"section":"testimonial-module--section--3sfzm","right":"testimonial-module--right--1KStb","image":"testimonial-module--image--3iL_c"};